import { ThunkDispatch } from 'redux-thunk';
import { AnyAction, combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import user from './user';
import story from './story';
import card from './card';
import editor from './editor';
import settings from './settings';

const rootReducer = combineReducers({
	user,
	story,
	card,
	editor,
	settings,
	form: formReducer,
});

export type ClientReducerState = ReturnType<typeof rootReducer>;

export type ClientThunkAction<A extends AnyAction = AnyAction, R = void> = (
	dispatch: ThunkDispatch<ClientReducerState, void, A>,
	getState: () => ClientReducerState
) => Promise<R>;

export default rootReducer;
